import React, { useCallback, useState } from 'react';
import cx from 'classnames';

import { setNumberWithComma } from '../../../../../lib/common';
import Modal from '../../../../../components/Modal';
import Anchor from '../../../../../components/link/Anchor';
import InfoTable from '../../../../../components/table/InfoTable';
import {
  INVALID_BULK_EDIT_PRODUCT_DISCOUNT_CASE_TYPE_TEXT,
  MINIMUM_PRICE_2000_WON_CATEGORY_NAME_LIST,
  VALID_BULK_EDIT_PRODUCT_DISCOUNT_CASE_TEXT,
} from '../../../../../constants/service/app/productConstants';
import { VALID_FILTER } from '../../../../../constants/service/common/utilConstants';
import './ExcelBulkEditProductDiscountFailModal.scss';

const ExcelBulkEditProductDiscountFailModal = (props) => {
  const { isOpen, data, openExcelBulkEditProductDiscountModal, closeModal } = props;
  const { requestCnt, possibleCnt, impossibleCnt, productList = [] } = data;
  const [validFilterValue, setValidFilterValue] = useState(VALID_FILTER.ALL);

  /**
   * @name getInvalidText
   * @description 할인 일괄 편집 적용 후 실패했을 경우 나타나는 텍스트
   * @param {string} category 카테고리 이름 (여러 개 등록한 경우도 한 문자열로 표현됨)
   * @param {number} invalidType 유효하지 않은 경우 타입
   * @return {string} 유효하지 않은 경우 원인 텍스트
   */
  const getInvalidText = useCallback((category, invalidType) => {
    const categoryList = category ? category.split(',') : [];

    // 1차 카테고리가 2개 이상 등록되어있을 경우
    if (categoryList.length > 1) {
      const categoryName = categoryList.filter((category) =>
        MINIMUM_PRICE_2000_WON_CATEGORY_NAME_LIST.includes(category.trim()),
      )[0];
      return categoryName
        ? `${categoryName} 상품의 할인 가격은 2,000원이상이여야 합니다.`
        : INVALID_BULK_EDIT_PRODUCT_DISCOUNT_CASE_TYPE_TEXT[invalidType];
    } else if (MINIMUM_PRICE_2000_WON_CATEGORY_NAME_LIST.includes(category)) {
      // 1차 카테고리의 최소 할인 가격이 2,000원 이상, 카테고리의 갯수가 1개로 등록되어있을 경우
      return `${category} 상품의 할인 가격은 2,000원이상이여야 합니다.`;
    }

    // 1차 카테고리의 최소 할인 가격이 9,900원 이상, 카테고리의 갯수가 1개로 등록되어있을 경우
    return INVALID_BULK_EDIT_PRODUCT_DISCOUNT_CASE_TYPE_TEXT[invalidType];
  }, []);

  const validFilter = (item) => {
    if (validFilterValue === VALID_FILTER.VALID) {
      return !item.isInvalid;
    } else if (validFilterValue === VALID_FILTER.INVALID) {
      return item.isInvalid;
    }

    return true;
  };

  return (
    <Modal
      title="상품 할인 일괄변경 실패"
      isOpen={isOpen}
      width={700}
      height={600}
      isFooter={true}
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <div className="excel-bulk-edit-product-discount-fail-modal-wrap">
        <div className="excel-bulk-edit-product-discount-fail-title">
          <div className="summary">
            <button
              type="button"
              className="request"
              onClick={() => {
                setValidFilterValue(VALID_FILTER.ALL);
              }}
            >
              요청:
              <span>{setNumberWithComma(requestCnt)}</span>
            </button>
            <button
              type="button"
              className="possible"
              onClick={() => {
                setValidFilterValue(VALID_FILTER.VALID);
              }}
            >
              가능:
              <span>{setNumberWithComma(possibleCnt)}</span>
            </button>
            <button
              type="button"
              className="impossible"
              onClick={() => {
                setValidFilterValue(VALID_FILTER.INVALID);
              }}
            >
              불가능:
              <span>{setNumberWithComma(impossibleCnt)}</span>
            </button>
          </div>
          <div>상품 할인 일괄변경에 실패를 하였습니다.</div>
          <div>아래 리스트에서 실패한 결과를 확인하시고,</div>
          <div>
            <span>수정을 한 뒤 다시 엑셀파일을 업로드하시기 바랍니다.</span>
            <Anchor
              isUnderLine
              color="primary"
              onClick={() => openExcelBulkEditProductDiscountModal()}
              text="엑셀 파일 다시 업로드하기"
            />
          </div>
        </div>

        {productList.length ? (
          <InfoTable>
            <thead>
              <tr>
                <th>순번</th>
                <th>상품 번호</th>
                <th colSpan={5}>결과</th>
              </tr>
            </thead>
            <tbody>
              {productList.filter(validFilter).map((item, index) => (
                <tr key={index}>
                  <td className="tc">{index + 1}</td>
                  <td className="tc">{item.productId}</td>
                  <td className={cx('tl', 'result', { isInvalid: item.isInvalid })} colSpan={5}>
                    {item.isInvalid
                      ? getInvalidText(item.mainCategory, item.invalidType)
                      : VALID_BULK_EDIT_PRODUCT_DISCOUNT_CASE_TEXT}
                  </td>
                </tr>
              ))}
            </tbody>
          </InfoTable>
        ) : (
          <div className="no-list-data">업로드된 엑셀파일에 유효한 상품리스트가 없습니다.</div>
        )}
      </div>
    </Modal>
  );
};

export default ExcelBulkEditProductDiscountFailModal;
